<template>
  <section class="dp-layout">
    <section class="dp-right op-page">
    <header class="op-page__head">
      <div>
        <div class="op-page__eyebrow">Outbound operations</div>
        <h3 class="op-page__title">开放同步任务</h3>
        <p class="op-page__desc">跟踪合作方请求从本地落库到天波出站的完整链路。结果待确认和人工处理任务必须先对账，再决定后续动作。</p>
      </div>
      <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="load">刷新任务</el-button>
    </header>

    <el-tabs v-model="tab" @tab-click="handleTab">
      <el-tab-pane label="批量任务" name="batch" />
      <el-tab-pane label="单条任务" name="single" />
      <el-tab-pane label="待重试" name="retryPending" />
      <el-tab-pane label="依赖阻塞" name="blocked" />
      <el-tab-pane label="结果待确认" name="unknownOutcome" />
      <el-tab-pane label="人工处理" name="manualReview" />
    </el-tabs>

    <div class="toolbar-filter-bar">
    <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent>
      <div class="toolbar-filter-fields">
      <el-form-item label="学校编号">
        <el-input v-model="filters.schoolDepartmentId" clearable class="toolbar-field-w-lg" />
      </el-form-item>
      <el-form-item label="请求编号">
        <el-input v-model="filters.requestId" clearable class="toolbar-field-w-xl" />
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="filters.resource" clearable class="toolbar-field-w-md">
          <el-option label="部门" value="dept" />
          <el-option label="学生" value="student" />
          <el-option label="教师" value="staff" />
          <el-option label="监护人" value="studentParent" />
          <el-option label="设备" value="device" />
          <el-option label="门禁规则" value="accessRule" />
          <el-option label="门禁子规则" value="accessSubRule" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
      </el-form-item>
      </div>
    </el-form>
    </div>

    <div class="tbl-scroll-host">
    <el-table v-if="tab === 'batch'" :data="tableData" v-loading="loading" size="small" stripe empty-text="暂无批量任务"
      height="100%" class="custom-tbl" style="width: 100%">
      <el-table-column prop="CreateTime" label="时间" width="158" />
      <el-table-column prop="RequestId" label="请求编号" min-width="150" show-overflow-tooltip />
      <el-table-column label="学校" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.SchoolName || '—' }}</div>
          <div class="op-sub">{{ scope.row.SchoolId }}</div>
        </template>
      </el-table-column>
      <el-table-column label="类型" width="100">
        <template slot-scope="scope">{{ entityTypeText(scope.row.Resource) }}</template>
      </el-table-column>
      <el-table-column label="动作" width="80">
        <template slot-scope="scope">{{ operationText(scope.row.Operation) }}</template>
      </el-table-column>
      <el-table-column prop="TotalCount" label="总数" width="70" align="right" />
      <el-table-column prop="SuccessCount" label="成功" width="70" align="right" />
      <el-table-column prop="FailCount" label="失败" width="70" align="right" />
      <el-table-column prop="ProcessingCount" label="处理中" width="80" align="right" />
    </el-table>

    <el-table v-else :data="tableData" v-loading="loading" size="small" stripe empty-text="暂无任务"
      height="100%" class="custom-tbl" style="width: 100%">
      <el-table-column prop="CreateTime" label="时间" width="158" />
      <el-table-column prop="RequestId" label="请求编号" min-width="140" show-overflow-tooltip />
      <el-table-column label="学校" min-width="130" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.SchoolName || '—' }}</div>
          <div class="op-sub">{{ scope.row.SchoolId }}</div>
        </template>
      </el-table-column>
      <el-table-column label="类型" width="100">
        <template slot-scope="scope">{{ entityTypeText(scope.row.Resource) }}</template>
      </el-table-column>
      <el-table-column label="动作" width="80">
        <template slot-scope="scope">{{ operationText(scope.row.Operation) }}</template>
      </el-table-column>
      <el-table-column label="本地编号" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="op-mono">{{ scope.row.LocalEntityId || '—' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ExternalId" label="外部标识" min-width="110" show-overflow-tooltip />
      <el-table-column label="状态" width="120">
        <template slot-scope="scope">
          <span :class="syncStatusClass(scope.row.SyncStatus)">{{ syncStatusText(scope.row.SyncStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="AttemptCount" label="尝试" width="60" align="right" />
      <el-table-column label="失败原因" min-width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :class="scope.row.ErrorMessage ? 'is-bad' : 'op-muted'">
            {{ failReasonText(scope.row.ErrorMessage, scope.row.SyncStatus === 'succeeded' ? '—' : '暂无，点详情看步骤') }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <div class="table-op-pair">
            <el-button type="text" size="small" class="table-op-link" @click="openDetail(scope.row)">详情</el-button>
            <el-button v-if="scope.row.SyncStatus === 'retryPending'" type="text" size="small" class="table-op-link"
              @click="retryNow(scope.row)">马上再试</el-button>
            <el-button v-if="scope.row.SyncStatus === 'unknownOutcome' || scope.row.SyncStatus === 'manualReview'"
              type="text" size="small" class="table-op-link" @click="openManual(scope.row)">人工处理</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <el-col :span="24" class="toolbar">
      <el-pagination layout="total, prev, pager, next" :current-page.sync="page" :page-size="pageSize"
        :total="total" style="float: right" @current-change="load" />
    </el-col>

    <el-dialog title="任务详情" :visible.sync="detailVisible" width="860px" custom-class="op-detail-dialog">
      <template v-if="detail">
        <el-alert
          type="info"
          :closable="false"
          title="本页任务最终会同步到天波。「天波调用尝试」是真正打到天波接口的记录。"
          style="margin-bottom:12px" />
        <el-alert
          v-if="detail.Operation === 'update' || detail.Operation === 'add'"
          type="warning"
          :closable="false"
          :title="localIdHint"
          style="margin-bottom:12px" />
        <el-descriptions :column="2" size="small" border class="op-desc">
          <el-descriptions-item label="状态">
            <span :class="syncStatusClass(detail.SyncStatus)">{{ syncStatusText(detail.SyncStatus) }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="类型">{{ entityTypeText(detail.Resource) }} / {{ operationText(detail.Operation) }}</el-descriptions-item>
          <el-descriptions-item label="请求编号" :span="2">{{ detail.RequestId }}</el-descriptions-item>
          <el-descriptions-item label="失败原因" :span="2">
            <span :class="detail.ErrorMessage ? 'is-bad' : ''">{{ failReasonText(detail.ErrorMessage, '无') }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="外部标识">{{ detail.ExternalId || '—' }}</el-descriptions-item>
          <el-descriptions-item label="本地编号">{{ detail.LocalEntityId || '—' }}</el-descriptions-item>
        </el-descriptions>

        <div class="op-block">
          <div class="op-block__title">命令摘要</div>
          <pre class="op-code">{{ prettyCommand }}</pre>
        </div>

        <div class="op-block">
          <div class="op-block__title">处理步骤</div>
          <el-table :data="detail.Steps || []" size="small" border stripe empty-text="无步骤记录" class="op-inner-table">
            <el-table-column label="步骤" min-width="160">
              <template slot-scope="scope">{{ stepNameText(scope.row.StepName) }}</template>
            </el-table-column>
            <el-table-column label="状态" width="130">
              <template slot-scope="scope">
                <span :class="syncStatusClass(scope.row.Status)">{{ syncStatusText(scope.row.Status) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="失败原因" min-width="180" show-overflow-tooltip>
              <template slot-scope="scope">{{ failReasonText(scope.row.ErrorMessage, '—') }}</template>
            </el-table-column>
          </el-table>
        </div>

        <div class="op-block">
          <div class="op-block__title">天波调用尝试</div>
          <el-table :data="detail.Attempts || []" size="small" border stripe empty-text="无天波调用记录" class="op-inner-table">
            <el-table-column prop="AttemptNo" label="次数" width="60" align="center" />
            <el-table-column prop="VendorPath" label="天波接口路径" min-width="180" show-overflow-tooltip />
            <el-table-column label="结果" width="120">
              <template slot-scope="scope">
                <span :class="statusClass(scope.row.Outcome)">{{ attemptOutcomeText(scope.row.Outcome) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="DurationMs" label="耗时毫秒" width="90" align="right" />
            <el-table-column label="失败原因" min-width="180" show-overflow-tooltip>
              <template slot-scope="scope">{{ failReasonText(scope.row.ErrorSummary, '—') }}</template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="人工对账处理" :visible.sync="manualVisible" width="520px" custom-class="op-config-dialog"
      :close-on-click-modal="false">
      <el-alert type="warning" :closable="false" title="先确认天波侧实际状态，再选动作。禁止盲目一键重试。" style="margin-bottom:12px" />
      <el-form label-width="120px" size="small">
        <el-form-item label="动作">
          <el-select v-model="manualForm.Action" style="width:100%">
            <el-option label="确认天波没建成功 → 进入再试" value="confirmNotCreated" />
            <el-option label="补录天波编号 → 标记成功" value="bindTbId" />
            <el-option label="标记已处理" value="markHandled" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="manualForm.Action === 'bindTbId'" label="天波编号">
          <el-input v-model="manualForm.TbEntityId" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="manualForm.Remark" type="textarea" :rows="2" placeholder="写清你核对了什么" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="manualVisible = false">取消</el-button>
        <el-button type="primary" @click="submitManual">确认执行</el-button>
      </div>
    </el-dialog>
    </section>
  </section>
</template>

<script>
import {
  getPartnerBatchPage,
  getPartnerOperationPage,
  getPartnerOperationDetail,
  retryPartnerOperationNow,
  manualHandlePartnerOperation
} from '@/api/modules/openPlatform';
import {
  entityTypeText,
  operationText,
  syncStatusText,
  syncStatusClass,
  failReasonText,
  attemptOutcomeText,
  stepNameText,
  prettyJsonText,
  statusClass
} from '@/utils/openPlatformLabels';

export default {
  name: 'SyncTaskCenter',
  data() {
    return {
      loading: false,
      tab: 'single',
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      filters: { schoolDepartmentId: '', requestId: '', resource: '' },
      detailVisible: false,
      detail: null,
      manualVisible: false,
      manualForm: { OperationId: 0, Action: 'confirmNotCreated', TbEntityId: '', Remark: '' }
    };
  },
  computed: {
    prettyCommand() {
      return prettyJsonText(this.detail && this.detail.CommandSnapshotSummary);
    },
    localIdHint() {
      if (!this.detail || !this.detail.LocalEntityId) return '';
      return `同一本地编号 ${this.detail.LocalEntityId} 的新增/修改是同一条数据的两次任务，不是建了两个人；手机号不同是因为改号请求。`;
    }
  },
  created() {
    if (this.$route.query.requestId) {
      this.filters.requestId = this.$route.query.requestId;
      this.tab = 'single';
    }
    this.load();
  },
  methods: {
    entityTypeText,
    operationText,
    syncStatusText,
    syncStatusClass,
    failReasonText,
    attemptOutcomeText,
    stepNameText,
    statusClass,
    handleTab() {
      this.page = 1;
      this.$nextTick(() => this.load());
    },
    handleSearch() {
      this.page = 1;
      this.load();
    },
    load() {
      this.loading = true;
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        tab: this.tab,
        ...this.filters
      };
      Object.keys(params).forEach(k => {
        if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k];
      });
      const req = this.tab === 'batch' ? getPartnerBatchPage(params) : getPartnerOperationPage(params);
      req.then(res => {
        this.loading = false;
        if (res.data && res.data.success) {
          const page = res.data.response || {};
          this.tableData = page.data || [];
          this.total = page.dataCount || 0;
        } else {
          this.$message.error((res.data && res.data.msg) || '加载失败');
        }
      }).catch(() => { this.loading = false; });
    },
    openDetail(row) {
      getPartnerOperationDetail(row.Id).then(res => {
        if (res.data && res.data.success) {
          this.detail = res.data.response;
          this.detailVisible = true;
        } else this.$message.error((res.data && res.data.msg) || '加载失败');
      });
    },
    retryNow(row) {
      this.$confirm('确认马上再试这一条失败任务？', '二次确认', { type: 'warning' })
        .then(() => retryPartnerOperationNow(row.Id))
        .then(res => {
          if (res.data && res.data.success) {
            this.$message.success('已安排再试');
            this.load();
          } else this.$message.error((res.data && res.data.msg) || '失败');
        })
        .catch(() => {});
    },
    openManual(row) {
      this.manualForm = {
        OperationId: row.Id,
        Action: 'confirmNotCreated',
        TbEntityId: '',
        Remark: ''
      };
      this.manualVisible = true;
    },
    submitManual() {
      const data = {
        OperationId: this.manualForm.OperationId,
        Action: this.manualForm.Action,
        Remark: this.manualForm.Remark
      };
      if (this.manualForm.Action === 'bindTbId') {
        data.TbEntityId = Number(this.manualForm.TbEntityId);
        if (!data.TbEntityId) {
          this.$message.warning('请填写天波编号');
          return;
        }
      }
      this.$confirm('确认执行人工对账？会写审计日志。', '二次确认', { type: 'warning' })
        .then(() => manualHandlePartnerOperation(data))
        .then(res => {
          if (res.data && res.data.success) {
            this.$message.success('已处理');
            this.manualVisible = false;
            this.load();
          } else this.$message.error((res.data && res.data.msg) || '失败');
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.op-sub { margin-top: 2px; font-size: 12px; color: #c0c4cc; }
.op-muted { color: #c0c4cc; }
.op-block { margin-top: 16px; }
.op-block__title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  padding-left: 8px;
  border-left: 3px solid var(--btn-primary, #2563eb);
}
.op-code {
  margin: 0;
  padding: 12px 14px;
  background: #1e1e1e;
  color: #d4d4d4;
  border-radius: 6px;
  font-family: Consolas, 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 220px;
  overflow: auto;
}
.op-inner-table { width: 100%; }
.op-desc >>> .el-descriptions-item__label { width: 96px; color: #606266; }
.op-mono { font-family: Consolas, Monaco, monospace; font-size: 12px; color: #606266; }
.is-ok { color: #67c23a; }
.is-warn { color: #e6a23c; }
.is-bad { color: #f56c6c; }
</style>
